export const getOpinionValue = (rent) => {
  switch (rent.user_feedback_opinion) {
    case  'bad':
      return -1;
    case  'neutral':
      return 0;
    case  'good':
      return 1;
    default:
      return -2;
  }
}



// WEBPACK FOOTER //
// ./src/services/RentService.js